<template>
  <pt-sample-recollect-detail class="pt-sample-recollect-detail__page" :sampleId="sampleId" :sampleType="sampleType"></pt-sample-recollect-detail>
</template>

<script>
import PtSampleRecollectDetail from 'cps/goods-order/pt-waiting-sample-recollect/pt-sample-recollect-detail/withData'
export default {
  name: 'pt-sample-recollect-detail__view',
  components: {
    'pt-sample-recollect-detail': PtSampleRecollectDetail
  },
  props: {
    sampleId: {
      type: String,
      default: ''
    },
    sampleType: {
      type: String,
      default: null
    }
  }
}
</script>
